<div>
    <Navbar />
    <Sidebar />
    <div class="page-wrapper">
        <div class="hero-section w-100">
            <div class="border rounded-4 p-2 custom-border">
                <!-- Header -->
                <div class="mb-4">
                <h2 class="gradient-text fw-bold">Role Management</h2>
                <p class="text-muted">Manage system roles and permission assignments</p>
                </div>

                <!-- Statistics Cards -->
                <div class="row text-center mb-3">
                    <div class="col-md-4 mb-3">
                        <div class="card rounded-4 shadow-sm users-card" @click="filter_type = 'all'">
                        <div class="card-body">
                            <p class="card-text display-5">{{ roles.length }}</p>
                            <h5 class="card-title">Total Roles</h5>
                        </div>
                        </div>
                    </div>

                    <div class="col-md-4 mb-3">
                        <div class="card rounded-4 shadow-sm users-card" @click="filter_type = 'active'">
                        <div class="card-body">
                            <p class="card-text display-5">{{ active_roles_count }}</p>
                            <h5 class="card-title">Active Roles</h5>
                        </div>
                        </div>
                    </div>

                    <div class="col-md-4 mb-3">
                        <div class="card rounded-4 shadow-sm users-card" @click="filter_type = 'inactive'">
                        <div class="card-body">
                            <p class="card-text display-5">{{ inactive_roles_count }}</p>
                            <h5 class="card-title">Inactive Roles</h5>
                        </div>
                        </div>
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="d-flex mb-2">
                    <button class="upload-button btn-sm text-white box-shadow small d-flex align-items-center"
                        data-bs-toggle="modal" data-bs-target="#addRoleModal">
                        <i class="fas fa-plus plus-icon me-1"></i> Add Role
                    </button>
                    <button class="upload-button btn-sm text-white box-shadow small d-flex align-items-center ms-2"
                        @click="$router.back()">
                        Back
                    </button>
                </div>
                <!-- Roles Table -->
                <div class="card table-card">
                    <div class="card-body">
                        <div v-if="roles_loading" class="text-center py-5">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <p class="mt-3 text-muted mb-0">Loading roles...</p>
                        </div>
                        <div v-else class="table-responsive content-table">
                            <table id="roles_table" class="table text-xs table-striped" data-sort="true">
                                <thead>
                                <tr>
                                    <th>No</th>
                                    <th>Role Name</th>
                                    <th>Description</th>
                                    <th>Created By</th>
                                    <th>Actions</th>
                                </tr>
                                </thead>
                                <tbody class="text-start text-xs">
                                <tr v-for="(role, index) in filtered_roles" :key="role.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ role.name }}</td>
                                    <td class="description-truncate">
                                        {{ truncate_text(role.description || 'No description', 100) }}
                                    </td>
                                    <td>{{role.created_by}}</td>
                                    <td>
                                    <div class="d-flex gap-2">
                                        <button class="btn btn-sm upload-button text-nowrap"
                                        @click="open_update_modal(role)"
                                        data-bs-toggle="modal"
                                        data-bs-target="#updateRoleModal">
                                        Edit
                                        </button>
                                        <button class="btn btn-sm upload-button text-nowrap"
                                        @click="open_manage_permissions_modal(role)">
                                        Manage Permissions
                                        </button>
                                        <button v-if="role.is_active"
                                        class="btn btn-sm btn-success text-nowrap action-btn-toggle"
                                        @click="toggle_role_status(role)">
                                        Deactivate
                                        </button>
                                        <button v-else
                                        class="btn btn-sm btn-danger text-nowrap action-btn-toggle"
                                        @click="toggle_role_status(role)">
                                        Activate
                                        </button>
                                    </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Add Role Modal -->
                <div class="modal fade" id="addRoleModal" tabindex="-1" aria-labelledby="addRoleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title gradient-text" id="addRoleModalLabel">Create New Role</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>

                        <div class="modal-body">
                            <form @submit.prevent="add_role">
                            <div class="mb-3 text-start">
                                <label for="role_name" class="ms-2">Role Name</label>
                                <input v-model="role_name"
                                type="text"
                                class="form-control"
                                id="role_name"
                                placeholder="e.g., Administrator"
                                required>
                            </div>

                            <div class="mb-3 text-start">
                                <label for="role_description" class="ms-2">Description</label>
                                <textarea v-model="role_description"
                                class="form-control"
                                id="role_description"
                                rows="3"
                                placeholder="Describe this role's responsibilities..."></textarea>
                            </div>

                            <div class="modal-footer">
                                <button type="submit" class="btn upload-button text-white" :disabled="role_loading">
                                <span v-if="role_loading" class="spinner-border spinner-border-sm me-2" role="status"
                                    aria-hidden="true"></span>
                                {{ role_loading ? 'Creating...' : 'Create Role' }}
                                </button>
                            </div>
                            </form>
                        </div>
                        </div>
                    </div>
                </div>

                <!-- Update Role Modal -->
                <div class="modal fade" id="updateRoleModal" tabindex="-1" aria-labelledby="updateRoleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title gradient-text" id="updateRoleModalLabel">
                            Update: {{ name }}
                            </h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>

                        <div class="modal-body">
                            <div class="mb-3 text-start">
                            <label for="update_role_name" class="ms-2">Role Name</label>
                            <input v-model="name"
                                type="text"
                                class="form-control"
                                id="update_role_name">
                            </div>
                            <div class="mb-3 text-start">
                            <label for="update_role_description" class="ms-2">Description</label>
                            <textarea v-model="description"
                                class="form-control"
                                id="update_role_description"
                                rows="3"></textarea>
                            </div>
                            <div class="modal-footer">
                            <button @click="update_role_basic_info"
                                class="btn btn-sm upload-button text-white"
                                :disabled="role_loading">
                                <span v-if="role_loading" class="spinner-border spinner-border-sm me-2"></span>
                                {{ role_loading ? 'Updating...' : 'Update' }}
                            </button>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>

                <!-- View Role Details Modal -->
                <div class="modal fade" id="viewRoleDetailsModal" tabindex="-1" aria-labelledby="viewRoleDetailsModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-lg">
                        <div class="modal-content">
                        <div class="modal-header border-bottom bg-light">
                            <h5 class="modal-title gradient-text fw-bold" id="viewRoleDetailsModalLabel">
                            Role Details: {{ selected_role_details?.name }}
                            </h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>

                        <div class="modal-body">
                            <div v-if="role_loading" class="text-center py-5">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            </div>

                            <div v-else-if="selected_role_details">
                            <!-- Role Info -->
                            <div class="mb-4">
                                <h6 class="fw-bold mb-3">Role Information</h6>
                                <div class="row">
                                <div class="col-md-6 mb-2">
                                    <small class="text-muted">Role Name:</small>
                                    <p class="mb-0">{{ selected_role_details.name }}</p>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <small class="text-muted">Status:</small>
                                    <p class="mb-0">
                                    <span :class="['badge', selected_role_details.is_active ? 'bg-success' : 'bg-danger']">
                                        {{ selected_role_details.is_active ? 'Active' : 'Inactive' }}
                                    </span>
                                    </p>
                                </div>
                                <div class="col-12 mb-2">
                                    <small class="text-muted">Description:</small>
                                    <p class="mb-0">{{ selected_role_details.description || 'No description' }}</p>
                                </div>
                                </div>
                            </div>

                            <!-- Assigned Permissions -->
                            <div>
                                <h6 class="fw-bold mb-3">
                                Assigned Permissions
                                <span class="badge bg-primary ms-2">{{ role_permissions.length }}</span>
                                </h6>

                                <div v-if="role_permissions && role_permissions.length > 0" class="permission-details-list">
                                <div v-for="permission in role_permissions"
                                    :key="permission.id"
                                    class="card mb-2">
                                    <div class="card-body p-3">
                                    <h6 class="mb-1">{{ permission.name }}</h6>
                                    <p class="text-muted small mb-0">{{ permission.description || 'No description' }}</p>
                                    </div>
                                </div>
                                </div>

                                <div v-else class="alert alert-info">
                                <i class="fas fa-info-circle me-2"></i>
                                No permissions assigned to this role
                                </div>
                            </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<PoweredBy/>